module.exports = __webpack_public_path__ + "img/zoho.dbaa64c0.png";